/*
 * Copyright (c) 2022.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Pavel Bobylev <pavel.bobylev1988@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export class TemplateCases {
  nominative: string;
  genitive: string;
  dative: string;
  accusative: string;
  creative: string;
  prepositional: string;

  nominativePlural: string;
  genitivePlural: string;
  dativePlural: string;
  accusativePlural: string;
  creativePlural: string;
  prepositionalPlural: string;
}
